import { FC, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang, Team, TFile } from '@brg/api';
import styled from 'styled-components';
import ProjectCardLayoutNew from '../projectCard/projectCardLayoutNew';
import { useAdBlockView } from '../../hooks/useAdBlockView';

export interface IAdBlock {
  adBlockText?: any[];
  adBlockLink?: string | null;
  adBlockImages?: any[];
  adBlockImageContainerId?: string | null;
  adBlockOriginalImageInfo?: any;
  isHidden?: boolean;
  position?: number;
}

export interface AdBlockCardProps {
  team?: Team;
  itemType?: string;
  currentTab?: string;
  onAdView?: () => void;
  fullWidth?: boolean;
  adBlock?: IAdBlock;
}

const toAdBlocks = (source: any): IAdBlock[] => {
  if (!source?.isShowAdBlock) return [];
  if (source.adBlocks?.length) {
    return source.adBlocks.filter((b: IAdBlock) => !b.isHidden);
  }
  if (source.adBlockImages?.length || source.adBlockText?.length || source.adBlockLink) {
    return [{
      adBlockText: source.adBlockText || [],
      adBlockLink: source.adBlockLink,
      adBlockImages: source.adBlockImages || [],
      adBlockImageContainerId: source.adBlockImageContainerId,
      adBlockOriginalImageInfo: source.adBlockOriginalImageInfo,
      position: 1,
    }];
  }
  return [];
};

export const getAdBlocks = (team: any, currentTab?: string): IAdBlock[] => {
  const tabs = team?.tabs || [];
  const tabData = currentTab
    ? tabs.find((tab: any) => tab.path === currentTab)
    : tabs.find((tab: any) => tab.isMain) || tabs[0];

  const tabBlocks = toAdBlocks(tabData);
  if (tabBlocks.length) return tabBlocks;

  return toAdBlocks(team);
};

export const getAdBlockGridIndex = (block: IAdBlock): number =>
  Math.max((block.position || 1) - 1, 0);

const PartnerBadge = styled.div`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #FFFFFF;
  backdrop-filter: blur(4px);
`;

export const AdBlockCard: FC<AdBlockCardProps> = ({ team, itemType, currentTab, onAdView, fullWidth, adBlock }) => {
  const { i18n, t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useAdBlockView({
    elementRef: containerRef,
    onAdView,
    disabled: !onAdView,
  });

  const adBlockCard = useMemo(() => {
    const block: IAdBlock | undefined = adBlock || getAdBlocks(team, currentTab)[0];
    if (!block) return null;

    const adBlockTitle = Lang(block.adBlockText || [], i18n.language) || '';

    let titleImages: TFile[] | undefined = undefined;
    if (block.adBlockImages?.length) {
      //@ts-ignore
      const originalImage = block.adBlockImages.find((img: any) => img.size === 'original' || !img.size) || block.adBlockImages[0];
      titleImages = originalImage ? [originalImage] : undefined;
    }

    const topBadge = fullWidth ? t('text.partner_material_cap') : <PartnerBadge>{t('text.partner_material')}</PartnerBadge>
    return (
      <ProjectCardLayoutNew
        key="ad-block-card"
        identifier={team?.teamId}
        title={adBlockTitle}
        titleImages={titleImages}
        linkTo={block.adBlockLink || undefined}
        linkTarget="_blank"
        withoutGoToProject={!block.adBlockLink}
        projectType={'t-shape'}
        lmsCardType={'t-shape'}
        itemType={itemType}
        topBadge={topBadge}
        isPartnerMaterial={fullWidth}
      />
    );
  }, [adBlock, team, i18n.language, itemType, currentTab, fullWidth]);

  if (!adBlockCard) return null;

  return (
    <div ref={containerRef} style={{ display: 'contents' }}>
      {adBlockCard}
    </div>
  );
};

import { FC, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang, Team, TFile } from '@brg/api';
import styled from 'styled-components';
import ProjectCardLayoutNew from '../projectCard/projectCardLayoutNew';
import { useAdBlockView } from '../../hooks/useAdBlockView';

export interface IAdBlock {
  adBlockText?: any[];
  adBlockLink?: string | null;
  adBlockImages?: any[];
  adBlockImageContainerId?: string | null;
  adBlockOriginalImageInfo?: any;
  isHidden?: boolean;
  position?: number;
}

export interface AdBlockCardProps {
  team?: Team;
  itemType?: string;
  currentTab?: string;
  onAdView?: () => void;
  fullWidth?: boolean;
  adBlock?: IAdBlock;
}

const toAdBlocks = (source: any): IAdBlock[] => {
  if (!source?.isShowAdBlock) return [];
  if (source.adBlocks?.length) {
    return source.adBlocks.filter((b: IAdBlock) => !b.isHidden);
  }
  if (source.adBlockImages?.length || source.adBlockText?.length || source.adBlockLink) {
    return [{
      adBlockText: source.adBlockText || [],
      adBlockLink: source.adBlockLink,
      adBlockImages: source.adBlockImages || [],
      adBlockImageContainerId: source.adBlockImageContainerId,
      adBlockOriginalImageInfo: source.adBlockOriginalImageInfo,
      position: 1,
    }];
  }
  return [];
};

export const getAdBlocks = (team: any, currentTab?: string): IAdBlock[] => {
  const tabs = team?.tabs || [];
  const tabData = currentTab
    ? tabs.find((tab: any) => tab.path === currentTab)
    : tabs.find((tab: any) => tab.isMain) || tabs[0];

  const tabBlocks = toAdBlocks(tabData);
  if (tabBlocks.length) return tabBlocks;

  return toAdBlocks(team);
};

export const getAdBlockGridIndex = (block: IAdBlock): number =>
  Math.max((block.position || 1) - 1, 0);

const PartnerBadge = styled.div`
  background: rgba(49, 49, 49, 0.4);
  border-radius: 3px;
  padding: 6px 18px;
  font-size: 12px;
  line-height: 1.2;
  color: #FFFFFF;
  backdrop-filter: blur(4px);
`;

export const AdBlockCard: FC<AdBlockCardProps> = ({ team, itemType, currentTab, onAdView, fullWidth, adBlock }) => {
  const { i18n, t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useAdBlockView({
    elementRef: containerRef,
    onAdView,
    disabled: !onAdView,
  });

  const adBlockCard = useMemo(() => {
    const block: IAdBlock | undefined = adBlock || getAdBlocks(team, currentTab)[0];
    if (!block) return null;

    const adBlockTitle = Lang(block.adBlockText || [], i18n.language) || '';

    let titleImages: TFile[] | undefined = undefined;
    if (block.adBlockImages?.length) {
      //@ts-ignore
      const originalImage = block.adBlockImages.find((img: any) => img.size === 'original' || !img.size) || block.adBlockImages[0];
      titleImages = originalImage ? [originalImage] : undefined;
    }

    const topBadge = fullWidth ? t('text.partner_material_cap') : <PartnerBadge>{t('text.partner_material')}</PartnerBadge>
    return (
      <ProjectCardLayoutNew
        key="ad-block-card"
        identifier={team?.teamId}
        title={adBlockTitle}
        titleImages={titleImages}
        linkTo={block.adBlockLink || undefined}
        linkTarget="_blank"
        withoutGoToProject={!block.adBlockLink}
        projectType={'t-shape'}
        lmsCardType={'t-shape'}
        itemType={itemType}
        topBadge={topBadge}
        isPartnerMaterial={fullWidth}
      />
    );
  }, [adBlock, team, i18n.language, itemType, currentTab, fullWidth]);

  if (!adBlockCard) return null;

  return (
    <div ref={containerRef} style={{ display: 'contents' }}>
      {adBlockCard}
    </div>
  );
};

